import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('App render error caught by ErrorBoundary:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
          <div className="bg-white rounded-[24px] p-10 shadow-[0_30px_80px_-45px_rgba(14,23,38,0.4)] max-w-md">
            <h1 className="font-display font-extrabold text-[#0E1726] text-[26px]">Something went wrong</h1>
            <p className="text-[#5B6472] mt-3">Please reload the page to continue. If it keeps happening, a hard refresh (Ctrl/Cmd+Shift+R) usually clears it.</p>
            <button onClick={this.handleReload} className="mt-6 bg-[#2E6BFF] text-white font-semibold px-6 py-3 rounded-full hover:bg-[#1f5aef] transition-colors">
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
